<div class="doc-thumb doc-thumb--activity" (click)="selected.emit(activity)">
    <div class="doc-thumb__image-wrapper">
        <!--  <div class="doc-thumb__is-new-wrapper" *ngIf="activity.isNew">
            <div class="doc-thumb__is-new">New!</div>
        </div> -->
        <div class="doc-thumb__image" [style.backgroundImage]="activity.coverImageStyleUrl"></div>
        <button class="doc-thumb__user-fav button-v2 --icon-only --red" *ngIf="isFav">
            <fa-icon [icon]="['tg', 'heart-solid']"></fa-icon>
        </button>
    </div>
    <div class="doc-thumb__title" *ngIf="!onlyImage">
        <fa-icon
            class="content-lock"
            [icon]="['tg', 'locked']"
            *ngIf="isContentRestricted"
            [ngClass]="{ '--green': activity.isPremiumContent }"></fa-icon>
        {{ activity.title }}
    </div>
    <!--     <div class="doc-thumb__subtitle" *ngIf="!onlyImage">Ages: {{ getAgeRange() }}</div>
 -->
</div>
